module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'p-animated-calc__column-one--section': _vm.showAddButton
    }
  }, [_c('div', {
    class: {
      'p-animated-calc__column-one--section-content': _vm.showAddButton
    }
  }, [_c('control', {
    attrs: {
      "name": 'dependant_income' + _vm.index,
      "label": 'Dependant ' + (_vm.index + 1) + ' Net Income',
      "no-flex-margin": true,
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.income),
      expression: "income",
      modifiers: {
        "number": true
      }
    }, {
      name: "field-control",
      rawName: "v-field-control:dependant_income.required",
      value: ({
        type: 'number'
      }),
      expression: "{type:'number'}",
      arg: "dependant_income",
      modifiers: {
        "required": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: _vm.reference,
    attrs: {
      "autocomplete": "off",
      "name": "dependant_income",
      "id": "dependantincome",
      "min": "0.00",
      "disabled": _vm.disabled,
      "type": "number"
    },
    domProps: {
      "value": (_vm.income)
    },
    on: {
      "focus": function($event) {
        _vm.income = _vm.income || ''
      },
      "blur": [function($event) {
        _vm.income = _vm.income || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.income = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('dependant_income')
    }
  }, [_vm._v("\n                The Dependant's Net income is required and must be a valid amount\n            ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "no-flex-margin": true
    }
  }, [(_vm.columnTwo) ? _c('div', [_c('div', {
    class: {
      'a-form-inputs--half-calcs': _vm.columnTwo
    }
  }, [_c('div', {
    class: {
      'a-form-inputs__container': _vm.columnTwo
    }
  }, [(_vm.showAddButton) ? _c('button', {
    staticClass: "a-button a-button--grow u-r-margin-bottom-0",
    class: {
      'p-dependency-calc__delete': this.index < 1
    },
    on: {
      "click": function($event) {
        return _vm.deleteDependant(_vm.index)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'a-form-inputs__container': _vm.columnTwo
    }
  }, [(_vm.showAddButton) ? _c('button', {
    staticClass: "a-button a-button--grow u-r-margin-top-0",
    on: {
      "click": _vm.addDependent
    }
  }, [_vm._v("Add")]) : _vm._e()])])]) : _c('div', [(_vm.showAddButton) ? _c('button', {
    staticClass: "a-button",
    class: {
      'p-dependency-calc__delete': this.index < 1
    },
    on: {
      "click": function($event) {
        return _vm.deleteDependant(_vm.index)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), (_vm.showAddButton) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.addDependent
    }
  }, [_vm._v("Add")]) : _vm._e()])]), _c('br')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f335add!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/CalculatorComponents/DependantIncome.vue
// module id = 1599
// module chunks = 0